import {combineReducers} from 'redux';
import {resettableReducer} from 'reduxsauce';
import  userReducer  from '../components/Users/reducer';

const resettableUserReducer = resettableReducer("RESET_USER");

export default combineReducers ({
   user: resettableUserReducer(userReducer) 
})